import styles from "./skyview.module.css";
import React, { useEffect, useState, useRef } from "react";
import { AiOutlinePaperClip } from "react-icons/ai";
import Card1 from '../assets/img/skyview/MARZO 2024.png';
import Card2 from '../assets/img/skyview/MAYO 2024.png';
import {
  Col,
  Row,
  Button,
  Modal,
  Container,
  Form,
  InputGroup,
  Stack
} from "react-bootstrap";
import {
  builtSolicitudDeServicio,
  SolicitudDeServicio,
  builtContratacionServicios,
  ContratacionServicios,
  AltaSolicitudDeServicio_Entrada,
  builtAltaSolicitudDeServicio_Entrada,
  AltaSolicitudDeServicio_Parametros,
  AltaSolicitudDeServicio_Respuesta,
  InfoPPE,
  builtInfoPPE
} from "../Commons/Services/AltaSolicitudDeServicioRest";


import { ConsultaWS } from "../Commons/ServiciosBase";
import Loading from "../General/Loading";
import ConfirmMessage from "../General/ConfirmMessage";
import { SSOrdenesCandadoRestService_Parametros, SSOrdenesCandadoRestService_Respuesta, SSOrdenesCandadoRestService_entrada, builtSSOrdenesCandadoRestServiceEntrada } from "../Commons/Services/SSOrdenesCandadoRestService";
import { ConsultaVeTVPricesRestService_Parametros, ConsultaVeTVPricesRestService_entrada, builtConsultaVeTVPricesRestServiceEntrada, ConsultaVeTVPricesRestService_Respuesta } from "../Commons/Services/ConsultaVeTVPricesRestService";

const SkyView = () => {

  const [loading, isLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [status, setStatus] = useState("OK");
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [precio, setPrecio] = useState("");
  const [direccion, setDireccion] = useState(sessionStorage.getItem("direccion"));




  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => {
    if (sessionStorage.getItem("tipoCliente") === "POS") {
      setShow(true);
    } else {
      setStatus("ERROR");
      setMessage("No está disponible para cuentas de prepago.");
      setShowAlert(true);
      setTimeout(() => {
      setShowAlert(false);
      }, 3000);
    }
  };

  const contrata = async () => {

    isLoading(true);
    const par : SSOrdenesCandadoRestService_entrada = builtSSOrdenesCandadoRestServiceEntrada(
                                                      sessionStorage.getItem("idSesion"),
                                                      "Revista",
                                                      "Y",
                                                      "Web",
                                                      sessionStorage.getItem("rowId"));

    const entrada = SSOrdenesCandadoRestService_Parametros(par);

    const respuesta: SSOrdenesCandadoRestService_Respuesta = await ConsultaWS(entrada);

    if(respuesta.codigoError.codigo === "0" && respuesta.codigoError.mensaje === "OK"){
      if(respuesta.resultado.RESUL === "N"){
        await altaSolicitud();        
        isLoading(false);
      }
      else{
        setStatus("ERROR");
        setMessage("Por el momento ya cuenta con una solicitud.");
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 3000);
      }
      isLoading(false);
    }else{
      setStatus("ERROR");
      setMessage("Error en la transacción.");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
      isLoading(false);
    }

    
  }

  const altaSolicitud = async () => {
    isLoading(true);
    const contratacionServicios: ContratacionServicios = builtContratacionServicios(
                                                         sessionStorage.getItem("Paquete")!,
                                                         "",
                                                         "",
                                                         "",
                                                         "",
                                                         "N");

    const infoPPE: InfoPPE = builtInfoPPE(
                             "",
                             "",
                             "",
                             "",
                             "",
                             "",
                             "",
                             "",
                             "",
                             "",
                             "",
                             "",
                             "0",
                             "",
                             "",
                             "",
                             "",
                             "");

    const altaSolicitud: SolicitudDeServicio = builtSolicitudDeServicio(
                                               sessionStorage.getItem("cuenta"),
                                               "Revista",
                                               "Reactivacion de Revista",
                                               "Web - "+direccion,
                                               "",
                                               sessionStorage.getItem("rowId"),
                                               sessionStorage.getItem("EmailNotif"),
                                               sessionStorage.getItem("pais"),
                                               sessionStorage.getItem("TipoCuenta"),
                                               sessionStorage.getItem("NombreSuscriptor"),
                                               null,
                                               null,
                                               contratacionServicios,
                                               null,
                                               null,
                                               infoPPE,
                                               null,
                                               null,
                                               "HIJUMP",
                                               sessionStorage.getItem("idSesion"));

    const entrada = builtAltaSolicitudDeServicio_Entrada(altaSolicitud);
    const par = AltaSolicitudDeServicio_Parametros(entrada);

    const respuesta: AltaSolicitudDeServicio_Respuesta = await ConsultaWS(par);

    if (respuesta.NumeroSolicitud && respuesta.NumeroSolicitud != null &&
        respuesta.NumeroSolicitud !== "") {

          setStatus("OK");
          setMessage("Suscripción exitosa no. solicitud: " + respuesta.NumeroSolicitud);
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
          }, 3000);
          isLoading(false);
          setShow(false);
      
    } else {
      setStatus("ERROR");
      setMessage("Error en la transacción.");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
      isLoading(false);
    }
  }

  const obtieneDatosRevista = async () => {

    isLoading(true);
    const par : ConsultaVeTVPricesRestService_entrada = builtConsultaVeTVPricesRestServiceEntrada(
                                                      "REVISTA_SKY");

    const entrada = ConsultaVeTVPricesRestService_Parametros(par);
    const respuesta: ConsultaVeTVPricesRestService_Respuesta = await ConsultaWS(entrada);
    
    if (respuesta.respuesta === "0" && respuesta.respuestaCode === "0") {
      setPrecio(String( respuesta.PRICE));
      isLoading(false);
    } else {
      setStatus("ERROR");
      setMessage("Error en la transacción.");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
      isLoading(false);
    }

  }

  useEffect(() => {
    obtieneDatosRevista();
  }, []);

  return (
    <>
      <Loading isLoading={loading} />
      <Container fluid className="p-0">
        <ConfirmMessage status={status} message={message} showAlert={showAlert} />
        <Row className={styles["headerRow"] + " " + styles["pl-45"]}>
          <Col style={{ paddingLeft: "0px" }}>
            <span className={styles["spectrum"]}>Revista Sky View</span>
          </Col>
        </Row>
        <Row className={styles["subheaderRowTitle"] + " " + styles["pl-50"]}>
          <Col style={{ paddingLeft: "0px" }}>
            <p className={styles["subtitleHeader"]}>
            Lee acerca de entretenimiento, viajes, deportes, espectaculos, cine, televisión y todas las novedades y promociones para suscriptores Sky. 
            </p>
          </Col>
        </Row>

        <Row className={styles["mynewbgcolor"]}>
          <Col className={styles["ml-50"]}>
            <p className={styles["subtitle"]}>
             Pide tu revista Sky View
            </p>

            <p className={styles["subtitle1"]}>
            Suscribete aquí por tan solo ${precio} al mes
            </p>

              <div  className={styles["aclararContainer"]}>
                  <div className={styles["divButton"]}>
                  <button
                    onClick={handleShow}
                    className={styles.button}
                  >
                    Contrata
                  </button>
                  </div>
                </div>
          </Col>
        </Row>

        <Row className={styles["subheaderRowTitleInferior"] + " " + styles["pl-50"]}>
          <Col>
            <h2 className={styles["subtitleHeader"]}>Nuestros Ejemplares Anteriores</h2>
          </Col>
        </Row>


        <div id="big" className="d-none d-xl-block d-lg-block ">
        <Row className={styles["rowImagenes"]}> 

          <Col >
            <img src={Card1} className={styles.imagenIzq}/>
            </Col>
            <Col>
            <img src={Card2} className={styles.imagenDer}/>
          </Col> 
          </Row>
        </div>

        <div id="small" className="d-lg-none d-xl-none">
          <Row  className={styles["rowImagenes"]}>
            <Col xs={12} sm={12} md={6} className={styles["colImagen"]}>
                <img src={Card1} className={styles.imagenSmallIzq}/>
            </Col>
            <Col xs={12} sm={12} md={6} className={styles["colImagen"]}>
                <img src={Card2} className={styles.imagenSmallDer}/>
          </Col> 
          </Row>
        </div> 

        {/* <Row className={styles["subheaderRowTitle"] + " " + styles["pl-50"]}>
          <Col>
            <p>Historico de Contratación de Revista</p>
          </Col>
        </Row> */}
      </Container >

      {/* <Container fluid className={styles["subheaderRowGrid"] + " " + styles["historialGrid"]}>
            <Row className={styles["subheaderRowGrid"] + " " + styles["gridHeader"]}>
            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                <span>No de Solicitud</span>
              </Col>
              <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                  <span>Fecha de Solicitud</span>
              </Col>
              <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                <span>Comentarios</span>
              </Col>
            </Row>
                <Row className={styles["subheaderRowGrid"] + " " + styles["grid"]} key={"bigRow_"} >
                  <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                    <span>w81-151516516189276</span>
                  </Col>
                  <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                    <span>10/04/2024</span>
                  </Col>
                  <Col xs={4} sm={4} md={4} lg={4} xl={4} className={styles["alignToLeft"]}                  >
                    <span>Sin Comentario</span>
                  </Col>

                </Row>
          </Container>  */}


      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header
          closeButton
          style={{ borderBottom: "none" }}
        ></Modal.Header>
        <Modal.Body>
          <div>
            <h2 className={styles.titulo}>
              ¿Quieres suscribirte a la revista Sky View?
            </h2>
            <p className={styles.descripcion}>
              Se agregará un cargo extra de ${precio} a tu próxima
              factura.
            </p>
            <p className={styles.descripcionDireccion}>
              <strong>Dirección de envío:</strong>
            </p>
            <p className={styles.descripcionDireccion}>{direccion} </p>
            <br />
            <Stack>
              <Button
                className={styles.botonModal}
                onClick={contrata}
              >
                {" "}
                Contratar{" "}
              </Button>
              <Button
                className={styles.botonCancelarModal}
                onClick={handleClose}
              >
                <b>Cancelar</b>
              </Button>
            </Stack>
          </div>
        </Modal.Body>
      </Modal>

      
    </>
  );
};

export default SkyView;
